/**
 * DevToolFlash Hook
 * Handles auto-dismissing flash messages in the dev tool panel
 * 
 * Features:
 * - Auto-dismiss after configurable timer
 * - Click to dismiss immediately
 * - Smooth fade out animation
 * - Progress bar to show time remaining
 */

const DevToolFlash = {
  mounted() {
    this.timer = null;
    this.timerLength = parseInt(this.el.dataset.timerLength) || 3000;
    this.type = this.el.dataset.type;

    // Start the auto-dismiss timer
    this.startTimer();

    // Add click handler for immediate dismiss
    this.el.addEventListener('click', () => this.dismiss());

    // Add progress bar if needed
    this.addProgressBar();
  },

  startTimer() {
    this.timer = setTimeout(() => {
      this.dismiss();
    }, this.timerLength);
  },

  addProgressBar() {
    // Create progress bar element
    const progressBar = document.createElement('div');
    progressBar.className = 'absolute bottom-0 left-0 h-1 bg-blue-600 transition-all duration-100';
    progressBar.style.width = '100%';
    progressBar.style.transitionDuration = `${this.timerLength}ms`;
    progressBar.style.transitionProperty = 'width';
    progressBar.style.transitionTimingFunction = 'linear';

    // Use appropriate color based on type
    if (this.type === 'error') {
      progressBar.classList.replace('bg-blue-600', 'bg-red-600');
    }

    this.el.appendChild(progressBar);

    // Start the animation
    requestAnimationFrame(() => {
      progressBar.style.width = '0%';
    });
  },

  dismiss() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    // Fade out animation
    this.el.style.transition = 'opacity 300ms ease-out';
    this.el.style.opacity = '0';

    // After fade out, trigger the clear flash event
    setTimeout(() => {
      this.pushEvent('clear_flash', { type: this.type });
    }, 300);
  },

  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
};

export default DevToolFlash;
